module.exports = "https://cdn.littlereply.com/tt/resource/follower_placeholder.b1fd29f5b9202fab61e9dd3401380a97.png";